<template id="home">
  <div id="home__security">
    <div class="home__cloud-svg"></div>
    <h1 class="home__security-header">Your passwords only for yourself.</h1>
    <p class="home__security-description">Only you can access to your critical data anywhere.</p>
    <div class="home__security-container">
      <div class="home__security-container__wrap">
        <div class="home__security-container__wrap-form">
          <div class="home__security-container__wrap-form-btn" @click="redirect">{{isLogged}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data () {
    return {
      isLogged: this.$store.getters.getUser.mail ? 'Logout' : 'Login'
    }
  },
  methods: {
    redirect () {
      if (this.$store.getters.getUser.mail) {
        this.$store.dispatch('logout')
        window.location.reload()
      } else {
        window.location.replace('/#/login')
      }
    }
  }
}
</script>

<style lang="scss">

#home__security {
  font-family: 'Poppins' sans-serif;
  height: auto;
  color: #3f3d56;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);
}
.home__security-svg {
  background-image: url('../assets/security.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  padding-top: 100vw;
  margin-top: 10vh;
}
.home__cloud-svg {
  background-image: url('../assets/hero.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  padding-top: 100vw;
  margin-top: 10vh;
}
.home__security-header {
  margin-top: 5vh;
  white-space: nowrap;
  font-size: 1.2em;
  text-align: center;
}

.home__security-description {
  margin-top: 3vh;
  text-align: center;
}

.home__security-container__wrap
{
  font-family: 'Poppins';
  font-size: 15px;
  color: #4caf50;
  line-height: 1.2;
  font-weight: bold;
  text-transform: uppercase;
  display: -webkit-flex;
  display: -webkit-box;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1px;
  padding:0 20px;
  height: 50px;
  width:100%;
  cursor: pointer;
  background: linear-gradient(to left top, #3ad29f, #17a1a8);
  color:#3f3d56;
  border-radius: 20px;
  width: 80vw;
  margin-top: 3vh;
}
.home__security-container__wrap-form-btn {
  color: #3f3d56 !important;
}

.home__security-container__wrap:hover
{
  background: #4caf50;
  color:#ddd;
}
.home__security-container__wrap:active
{
  background: rgb(255,145,19);
  color:#ddd;
}
.home__security-container__text-center
{
  text-align: center;
  padding-top: 20px;
}
.home__security-container__txt1
{
  font-family: 'Poppins';
  font-size: 13px;
  color: #666666;
  line-height: 1.5;
  text-align: center;
}
.warning {
  color: #ca2a2a;
}
.home__security-container__txt2
{
  font-family: 'Poppins';
  font-size: 13px;
  color: #333333;
  line-height: 1.5;
  text-decoration: none;
  transition: all 0.4s;
}
.txt2:hover
{
  text-decoration: underline;
}
@media screen and (max-height: 700px) {
  .home__security-description {
    display: none;
  }
  .home__security-header {
    font-size: 1em;
    margin-top: 2.5vh;
  }
  .home__cloud-svg {
    margin-top: 5vh;
  }
}
@media (min-width: 700px)
{
  .home__cloud-svg, .home__security-svg {
    width: 50vh;
    padding-top: 50vh;
  }
  .home__security-container__wrap {
    width: 40vh;
  }
}
</style>
